import React, { useState, useEffect, useRef } from "react";
import { WebMercatorViewport } from "@deck.gl/core";

function StickyEventTooltip({ viewport, tooltip, onClose }: { viewport: any; tooltip: any; onClose: () => void }) {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isInViewport, setIsInViewport] = useState(true);
  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (tooltip && viewport) {
      const vp = new WebMercatorViewport(viewport) as any;
      const [x, y] = vp.project([tooltip.longitude, tooltip.latitude]);

      // Check if coordinates are within viewport bounds
      const isXInBounds = x >= 0 && x <= viewport.width;
      const isYInBounds = y >= 0 && y <= viewport.height;
      setIsInViewport(isXInBounds && isYInBounds);

      setPos({ x, y });
    }
  }, [viewport, tooltip]);

  useEffect(() => {
    if (listRef.current) {
      const el = listRef.current;
      setIsOverflowing(el.scrollHeight > el.clientHeight);
    }
  }, [tooltip]);

  if (!tooltip || !isInViewport) return null;

  return (
    <div
      style={{
        position: "absolute",
        left: pos.x,
        top: pos.y,
        backgroundColor: "white",
        padding: "12px 16px",
        borderRadius: "4px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
        transform: "translate(-50%, calc(-100% - 12px))",
        zIndex: 9999,
        width: "300px",
        maxHeight: "250px",
        overflowY: "auto",
        pointerEvents: "auto",
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: "5px",
          right: "5px",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "16px",
          lineHeight: "1",
        }}
        aria-label="Close tooltip"
      >
        ×
      </button>

      <p className="text-lg font-semibold leading-6 text-blue-300">
        {tooltip.eventType}
      </p>
      <p className="text-sm">
        <strong>Time:</strong> {tooltip.eventTimestamp}
      </p>
      <p className="text-sm">
        <strong>Time From Start:</strong> {tooltip.timeFromStart}
      </p>
      {tooltip.depth !== undefined && tooltip.depth !== null && (
        <p className="text-sm">
          <strong>Depth:</strong> {tooltip.depth.toFixed(1)} m
        </p>
      )}
      {tooltip.freeText && (
        <p className="text-sm">
          <strong>Description:</strong> {tooltip.freeText}
        </p>
      )}
      {tooltip.eventOptions?.length > 0 && (
        <div>
          <h3 className="text-sm">
            <strong>Additional Info:</strong>
          </h3>
          <ul
            ref={listRef}
            className={`max-h-16 overflow-y-scroll px-0.5 text-sm ${
              isOverflowing ? "border" : ""
            }`}
            style={{ scrollbarGutter: "stable" }}
          >
            {tooltip.eventOptions.map((opt: any, idx: number) => (
              <li key={idx}>
                <strong>- {opt.event_option_name}:</strong>{" "}
                {opt.event_option_value}
              </li>
            ))}
          </ul>
        </div>
      )}
      <p className="cursor-not-allowed text-sm text-gray-400">
        <span className="underline">View All Images/Videos</span> (Coming Soon!)
      </p>
    </div>
  );
}

export default StickyEventTooltip;
